module.exports = __webpack_public_path__ + "assets/img/ground.a89697f1.png";